import { axiosInstance } from 'services';
import { AxiosResponse } from 'axios';

import { API_KEY } from 'constants/apis';
import { getDeepDAOTokenFromStorage } from 'web3/storageHelper';

import {
    IOrganizationAssets,
    IOrganizationDecisionsData,
    IOrganizationInfoData,
    IOrganizationSimilarDao,
    IOrganizationActivityData,
    IOrganizationCurrenciesData,
    IOrganizationMembersData,
    ICoalitionsData,
    IOrganizationTopShareholdersData,
    IAumGraphData,
    IOrganizationDaosData,
    IMainCountersData,
    IDiscussionItems,
    ICreateDiscussionElement,
    IDicussionComment,
    IGetOrganizationBalanceData,
    IOrganizationFeatureItems,
    IProjectToken,
    IOrganizationTool,
    IOrganizationSubstorm,
    IFollowingResponse,
    IOrganizationAssetsTable,
    IDaoVoter,
    IDaoProposer,
    IResponse,
} from 'types/interfaces';
import { organizationsHeaderMock } from 'mockedData/mainPage';
import {assetsMock, aumGraphMocked, execSummaryMock, organizationMock, orgDaosMock, substormMock, toolsMock} from 'mockedData/organization.page';
import { currenciesMock, daoAssetsMock } from 'mockedData/org_treasury.page';
import { topShareholdersMock } from 'mockedData/org_token.tab';
import { daoProposersMock, daoVotersMock } from 'mockedData/org_members_tab';
import { govActivityMock } from 'mockedData/org_voter_trends.tab';
import { duosCoalitionMock, foursCoalitionMock, triosColitionMock } from 'mockedData/org_coalitions.tab';

export const OrganizationApi = {
    getOrganizationData: (organizationId: string): Promise<AxiosResponse<any>> =>
      Promise.resolve({
        data: organizationMock,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        request: {},
      }),
        //axiosInstance.get<IOrganizationInfoData>(`organization/${API_KEY}/${organizationId}`),
    getOrganizationSimilarDaos: (organizationId: string): Promise<AxiosResponse<IOrganizationSimilarDao[]>> =>
        axiosInstance.get<IOrganizationSimilarDao[]>(
            `organization/${API_KEY}/${organizationId}/organization_mutual_voters`,
        ),
    getOrganizationAssets: (organizationId: string): Promise<AxiosResponse<any>> =>
        //axiosInstance.get<IOrganizationAssets>(`organization/${API_KEY}/${organizationId}/assets`),
        Promise.resolve({
          data: assetsMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationDaoAssetsTable: (organizationId: string): Promise<AxiosResponse<any>> =>
        //axiosInstance.get<IOrganizationAssetsTable>(`organization/${API_KEY}/${organizationId}/dao_assets`),
        Promise.resolve({
          data: daoAssetsMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationDecisions: async (daoId: string): Promise<AxiosResponse<any>> => {
          const jsonRes = await fetch('/decision_mock.json');
          const data = await jsonRes.json();
          
          return Promise.resolve({
            data,
            status: 200,
            statusText: "OK",
            headers: {},
            config: {},
            request: {},
          })
      },
        //axiosInstance.get<IOrganizationDecisionsData>(`organization/${API_KEY}/${daoId}/governance/decisions`),
    getOrganizationActivity: (organizationId: string): Promise<AxiosResponse<any>> =>
        //axiosInstance.get<IOrganizationActivityData>(`organization/${API_KEY}/${organizationId}/governance/activity`),
        Promise.resolve({
          data: govActivityMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationCurrencies: (organizationId: string): Promise<AxiosResponse<any>> =>
        //axiosInstance.get<IOrganizationCurrenciesData>(`organization/${API_KEY}/${organizationId}/currencies`),
        Promise.resolve({
          data: currenciesMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationMainInfo: (): Promise<AxiosResponse<IMainCountersData>> =>
      Promise.resolve({
        data: organizationsHeaderMock,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        request: {},
      }),
    getOrganizationProjectToken: (organizationId: string): Promise<AxiosResponse<IProjectToken>> =>
        //axiosInstance.get<IProjectToken>(`discussion/${organizationId}/projectToken`),
        Promise.resolve({
          data: {},
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationTools: (): Promise<AxiosResponse<any>> =>
        //axiosInstance.get<IOrganizationTool[]>(`organization/${API_KEY}/tools`),
        Promise.resolve({
          data: toolsMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationMembers: (daoId: string): Promise<AxiosResponse<IOrganizationMembersData>> =>
        axiosInstance.get<IOrganizationMembersData>(`organization/${API_KEY}/${daoId}/members`),
    getDaoVoters: (daoId: string): Promise<AxiosResponse<any>> =>
        //axiosInstance.get<IResponse<IDaoVoter[]>>(`organization/${API_KEY}/${daoId}/dao_voters`),
        Promise.resolve({
          data: daoVotersMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getDaoProposers: (daoId: string): Promise<AxiosResponse<any>> =>
        //axiosInstance.get<IResponse<IDaoProposer[]>>(`organization/${API_KEY}/${daoId}/dao_proposers`),
        Promise.resolve({
          data: daoProposersMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationCoalitions: (organizationId: string, membersInGroup = 2): Promise<AxiosResponse<any>> => {
      let data;
      switch (membersInGroup) {
          case 2: 
            data = duosCoalitionMock;
            break;

          case 3: 
            data = triosColitionMock;
            break;

          case 4: 
            data = foursCoalitionMock;
            break;

          // case 5: 
          //   data = {};
          //   break;
          
          // default:
          //   data
        
      }

      return Promise.resolve({
        data,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        request: {},
      });
    },
        // axiosInstance.get<ICoalitionsData>(
        //     `/organization/${API_KEY}/${organizationId}/calculated-coalitions?membersInGroup=${membersInGroup}`,
        // ),
    getOrganizationTopShareholdersByHoldings: (
        organizationId: string,
    ): Promise<AxiosResponse<IOrganizationTopShareholdersData>> =>
        // axiosInstance.get<IOrganizationTopShareholdersData>(
        //     `organization/${API_KEY}/${organizationId}/top-shareholders`,
        // ),
        Promise.resolve({
          data: topShareholdersMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationTopActiveShareholders: (
        organizationId: string,
    ): Promise<AxiosResponse<IOrganizationTopShareholdersData>> =>
        axiosInstance.get<IOrganizationTopShareholdersData>(
            `organization/${API_KEY}/${organizationId}/top-shareholders-by-activity`,
        ),
    getOrganizationAumGraph: (organizationId: string): Promise<AxiosResponse<any>> =>
        //axiosInstance.get<IAumGraphData>(`organization/${API_KEY}/${organizationId}/aum-graph`),
        Promise.resolve({
          data: aumGraphMocked,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationDao: (organizationId: string): Promise<AxiosResponse<any>> =>
        //axiosInstance.get<IOrganizationDaosData>(`organization/${API_KEY}/${organizationId}/dao`),
        Promise.resolve({
          data: orgDaosMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationDiscussions: ({
        organizationId,
        discussionsFilters,
        address,
    }: {
        organizationId: string;
        discussionsFilters: string;
        address?: string;
    }): Promise<AxiosResponse<IDiscussionItems[]>> =>
        // axiosInstance.get<IDiscussionItems[]>(
        //     `discussion/${organizationId}${discussionsFilters}${address ? `&address=${address}` : ''}`,
        // ),
        Promise.resolve({
          data: [],
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    createDiscussion: ({
        organizationId,
        data,
    }: {
        organizationId: string;
        data: ICreateDiscussionElement;
    }): Promise<AxiosResponse<IDiscussionItems>> =>
        axiosInstance.post<IDiscussionItems>(`discussion/${organizationId}`, data, {
            headers: { Authorization: `Bearer ${getDeepDAOTokenFromStorage()}` },
        }),
    createDiscussionVote: ({
        id,
        organizationId,
        data,
    }: {
        id: string;
        organizationId: string;
        data: ICreateDiscussionElement;
    }): Promise<AxiosResponse<IDiscussionItems>> =>
        axiosInstance.post<IDiscussionItems>(`discussion/vote/${organizationId}/${id}`, data, {
            headers: { Authorization: `Bearer ${getDeepDAOTokenFromStorage()}` },
        }),
    createDiscussionComment: ({
        id,
        organizationId,
        data,
    }: {
        id: string;
        organizationId: string;
        data: ICreateDiscussionElement;
    }): Promise<AxiosResponse<IDicussionComment>> =>
        axiosInstance.post<IDicussionComment>(`discussion/comment/${organizationId}/${id}`, data, {
            headers: { Authorization: `Bearer ${getDeepDAOTokenFromStorage()}` },
        }),
    getDiscussionComments: (id: string): Promise<AxiosResponse<IDicussionComment[]>> =>
        axiosInstance.get<IDicussionComment[]>(`discussion/comment/${id}`, {
            headers: { Authorization: `Bearer ${getDeepDAOTokenFromStorage()}` },
        }),
    getOrganizationBalance: (organizationId: string): Promise<AxiosResponse<IGetOrganizationBalanceData>> =>
        axiosInstance.get<IGetOrganizationBalanceData>(`discussion/get-balance/${organizationId}`, {
            headers: { Authorization: `Bearer ${getDeepDAOTokenFromStorage()}` },
        }),
    getOrganizationFeatures: (organizationId: string): Promise<AxiosResponse<IOrganizationFeatureItems>> =>
        axiosInstance.get<IOrganizationFeatureItems>(
            `organization/${API_KEY}/features?organizationId=${organizationId}`,
        ),
    getUserOrganizationRole: (organizationId: string): Promise<AxiosResponse<any>> =>
        axiosInstance.get<any>(`/self-listing/${organizationId}/user-organization-role`, {
            headers: { Authorization: `Bearer ${getDeepDAOTokenFromStorage()}` },
        }),
    getOrganizationDiscussionsMembers: ({
        organizationId,
        search,
    }: {
        [key: string]: string;
    }): Promise<AxiosResponse<any>> =>
        axiosInstance.get<any>(`/discussion/${organizationId}/members?limit=10${search ? '&search=' + search : ''}`),
    banDiscussionElement: ({ organizationId, elementId, dataForBan }: any): Promise<AxiosResponse<any>> =>
        axiosInstance.put<any>(`/discussion/${organizationId}?id=${elementId}`, dataForBan, {
            headers: { Authorization: `Bearer ${getDeepDAOTokenFromStorage()}` },
        }),
    getOrganizationDiscussion: (
        organizationId: string,
        discussionId: string,
        address?: string,
    ): Promise<AxiosResponse<IDiscussionItems>> =>
        axiosInstance.get<IDiscussionItems>(
            `discussion/${organizationId}/discussion?discussionId=${discussionId}${
                address ? `&address=${address}` : ''
            }`,
        ),
    updateOrganizationDiscussion: (
        organizationId: string,
        discussionId: string,
        data: any,
    ): Promise<AxiosResponse<IDiscussionItems>> =>
        axiosInstance.patch<IDiscussionItems>(
            `discussion/${organizationId}/discussion?discussionId=${discussionId}`,
            data,
            { headers: { Authorization: `Bearer ${getDeepDAOTokenFromStorage()}` } },
        ),
    getOrganizationSubstorms: (organizationId: string): Promise<AxiosResponse<IOrganizationSubstorm[]>> =>
        //axiosInstance.get<IOrganizationSubstorm[]>(`discussion/${organizationId}/substorms`),
        Promise.resolve({
          data: substormMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
    getOrganizationIsFollowingData: (organizationId: string): Promise<AxiosResponse<IFollowingResponse>> =>
        axiosInstance.get<IFollowingResponse>(`social-features/following-organization/${organizationId}`, {
            headers: { Authorization: `Bearer ${getDeepDAOTokenFromStorage()}` },
        }),
    followOrganization: (organizationId: string): Promise<AxiosResponse<IFollowingResponse>> =>
        axiosInstance.post<IFollowingResponse>(`social-features/follows-organization/${organizationId}`, null, {
            headers: { Authorization: `Bearer ${getDeepDAOTokenFromStorage()}` },
        }),
    unFollowOrganization: (organizationId: string): Promise<AxiosResponse<IFollowingResponse>> =>
        axiosInstance.delete<IFollowingResponse>(`social-features/unfollows-organization/${organizationId}`, {
            headers: { Authorization: `Bearer ${getDeepDAOTokenFromStorage()}` },
        }),
    getExecutiveStats: (organizationId: string): Promise<AxiosResponse<any>> =>
      Promise.resolve({
        data: execSummaryMock,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        request: {},
      }),
        //axiosInstance.get<any>(`organization/${API_KEY}/${organizationId}/exec_summary`),
};
